// extracted by mini-css-extract-plugin
module.exports = {"btnGreen":"styles_btnGreen__37gCk","btnRed":"styles_btnRed__3gHE5","container":"styles_container__3iIVT","title":"styles_title__Gf5uq"};